import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';

const SprayJobDetailWrapper = styled.div`
  width: 100%;

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    color: #333;
    padding: 16px 24px;
    border-radius: 8px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;
  }

  .page-header h1 {
    font-size: 24px;
    margin: 0;
    color: #333;
  }

  .detail-section {
    background: white;
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 16px;
  }

  .detail-section h3 {
    margin-bottom: 16px;
    color: #333;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 8px;
  }

  .zone-card {
    border: 1px dashed #d9d9d9;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
  }

  .zone-comment {
    margin-top: 8px;
    padding: 8px 12px;
    background: #fafafa;
    border-radius: 4px;
    font-style: italic;
    color: #666;
  }

  .chemical-row {
    padding: 8px 0;
    border-bottom: 1px solid #f5f5f5;
  }

  .chemical-row:last-child {
    border-bottom: none;
  }

  .status-badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 4px;
    font-weight: 500;
  }
`;

export default WithDirection(SprayJobDetailWrapper);
